import { AccountDetailFields, ValidationRule } from '@shared/types/enach.types';

export const NUMERIC_ONLY_REGEX = /\D/g;

// these are blacklist regexes - designed to match invalid characters below are whitelist regexes
export const ALPHANUMERIC_ONLY_REGEX = /[^A-Za-z0-9]/g;

export const ALPHANUMERIC_WITH_SPACE_REGEX = /[^A-Za-z0-9 ]/g;

export const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/;

// Validation regexes (whitelist — match valid input, no global flag)
export const ALPHANUMERIC_ONLY_VALID_REGEX = /^[A-Za-z0-9]+$/;
export const ALPHANUMERIC_WITH_SPACE_VALID_REGEX = /^[A-Za-z0-9 ]+$/;

export const ACCOUNT_NUMBER_MAX_LENGTH = 20;
export const IFSC_MAX_LENGTH = 11;
export const ACCOUNT_HOLDER_NAME_MAX_LENGTH = 250;

export const AccountFormFieldValidations: Record<
	AccountDetailFields,
	ValidationRule[]
> = {
	[AccountDetailFields.ACCOUNT_NUMBER]: [
		{
			type: 'LENGTH',
			validationId: 'VAL2110291054469824728170',
			message:
				'The bank account number provided should have more than 9 and less than 21 characters',
			active: true,
			maxLength: 20,
			minLength: 9,
			showErrorAfterLength: 0,
		},
	],
	[AccountDetailFields.IFSC]: [
		{
			type: 'LENGTH',
			validationId: 'VAL2210291054469824728171',
			message: 'Enter a valid IFSC code having 11 characters',
			active: true,
			maxLength: 11,
			minLength: 11,
			showErrorAfterLength: 0,
		},
		{
			type: 'REGEX',
			validationId: 'VAL2110291054469824728172',
			message: 'IFSC code should not contain special characters or spaces',
			active: true,
			regex: ALPHANUMERIC_ONLY_VALID_REGEX,
		},
		{
			type: 'REGEX',
			validationId: 'VAL2110291054469824728173',
			message: 'Enter a valid IFSC code',
			active: true,
			regex: IFSC_REGEX,
		},
	],
	[AccountDetailFields.ACCOUNT_HOLDER_NAME]: [
		{
			type: 'LENGTH',
			validationId: 'VAL2110291054469824728174',
			message:
				'The bank account name provided should have more than 2 and less than 250 characters',
			active: true,
			maxLength: 250,
			minLength: 2,
			showErrorAfterLength: 0,
		},
		{
			type: 'REGEX',
			validationId: 'VAL2110291054469824728175',
			message: 'The account name provided should be alphanumeric',
			active: true,
			regex: ALPHANUMERIC_WITH_SPACE_VALID_REGEX,
		},
	],
	[AccountDetailFields.ACCOUNT_TYPE]: [
		{
			type: 'LENGTH',
			validationId: 'VAL2110291054469824728176',
			message: 'Please select account type',
			active: true,
			maxLength: 25,
			minLength: 5,
		},
	],
};
